import { render } from "./modal-login-form.vue?vue&type=template&id=f3056df4"
import script from "./modal-login-form.vue?vue&type=script&lang=js"
export * from "./modal-login-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__